// src/pages/ApiDocsPage.jsx
import React, { useEffect } from "react";
import { Block, BlockHead, BlockHeadContent, BlockTitle } from "@/components/block/Block";
import { apiUrl } from "@/utils/apiUrl";

const ApiDocsPage = () => {
  useEffect(() => {
    // Redirect to the actual Swagger docs
    window.location.assign(apiUrl("/api/docs/"));
  }, []);

  return (
    <Block>
      <BlockHead>
        <BlockHeadContent>
          <BlockTitle tag="h4">API Documentation</BlockTitle>
          <p className="text-soft">Redirecting to Swagger API documentation...</p>
        </BlockHeadContent>
      </BlockHead>
    </Block>
  );
};

export default ApiDocsPage;
